export default ({ fill }) => (
  /**
   * Ícone utilizado para alinhamento do
   * rótulo a direita da feição
   */
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8398 0.546875H17.5065V17.2135H15.8398V0.546875ZM0.839844 7.21354H14.1732V4.71354H0.839844V7.21354ZM5.83984 13.0469H14.1732V10.5469H5.83984V13.0469Z"
      fill={fill || '#797E82'}
    />
  </svg>
);
